import { Link } from "react-router-dom";
import { Tiles } from "@/components/motion/Tiles";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES, byCategory } from "@/data/fleet";
import { EASE, Item, Lines, Reveal, Stagger } from "@/components/motion/Reveal";

const Panel = ({ cat, index }) => {
  const count = byCategory(cat.slug).reduce((a, v) => a + (v.units || 1), 0);
  return (
    <Item className="group relative h-[70vh] min-h-[440px] overflow-hidden bg-ink text-white">
      <Link to={`/parco-mezzi/${cat.slug}`} className="absolute inset-0 z-10" aria-label={cat.name} data-testid={`category-panel-${cat.slug}`} />
      <motion.img
        src={cat.image}
        alt={cat.name}
        style={{ objectPosition: cat.imagePosition }}
        className="absolute inset-0 h-full w-full object-cover opacity-60 transition-[transform,opacity] duration-[1.2s] ease-out group-hover:scale-105 group-hover:opacity-80"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
      <div className="absolute left-6 top-6 flex items-center gap-3 sm:left-8 sm:top-8">
        <Tiles count={3} size={8} offset={index * 3} />
        <span className="font-mono text-xs text-white/60">0{index + 1}</span>
        <span className="h-px w-10 bg-white/30" />
        <span className="eyebrow text-white/70">{cat.eyebrow}</span>
      </div>
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
        <p className="font-mono text-[11px] uppercase tracking-widest text-blue-500">{count} mezzi disponibili</p>
        <h3 className="display mt-2 text-4xl sm:text-5xl lg:text-6xl">{cat.name}</h3>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-white/70 sm:text-base">{cat.short}</p>
        <div className="mt-6 inline-flex items-center gap-2 font-display text-base font-bold uppercase tracking-wider">
          Vedi i mezzi
          <span className="flex h-9 w-9 items-center justify-center border border-white/30 transition-[background-color,border-color] duration-300 group-hover:border-blue-500 group-hover:bg-blue-500">
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </div>
    </Item>
  );
};

export const Categories = () => (
  <section className="bg-white py-24 sm:py-32" data-testid="categories-section">
    <div className="container-x">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Reveal y={10}><p className="eyebrow flex items-center gap-3"><Tiles />Parco mezzi</p></Reveal>
          <Lines as="h2" lines={["Due famiglie di mezzi,", "un solo interlocutore."]} className="display mt-4 text-4xl text-ink sm:text-5xl lg:text-6xl" />
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <p className="text-base leading-relaxed text-ink/60 sm:text-lg">
            Dal movimento terra al lavoro in quota: scegli il mezzo, noi lo portiamo in cantiere. Tutti i mezzi sono revisionati e pronti all'uso.
          </p>
        </Reveal>
      </div>
      <Stagger className="mt-14 grid gap-4 md:grid-cols-2" gap={0.15}>
        {Object.values(CATEGORIES).map((c, i) => (
          <Panel key={c.slug} cat={c} index={i} />
        ))}
      </Stagger>
    </div>
  </section>
);
